export default "__VITE_ASSET__CFNWfB1L__"